/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from 'react';

import { useAuth } from '@/hooks/useAuth';
import { createSupabaseClient } from '@/integrations/supabase/client';

export interface ExperimentItem {
  id: string;
  name: string;
  updatedAt: string | null;
}

type ExperimentRow = {
  id: string;
  title: string;
  updated_at: string | null;
};

export const useExperiments = () => {
  const [experiments, setExperiments] = useState<ExperimentItem[]>([]);
  const [loading, setLoading] = useState(false);
  const { user, getToken } = useAuth();

  const supabase = useMemo(() => createSupabaseClient(getToken), [getToken]);

  const fetchExperiments = async () => {
    if (!user) {
      return;
    }

    setLoading(true);
    try {
      const { data } = await supabase
        .from('experiments')
        .select('id, title, updated_at')
        .eq('user_id', user.id)
        .order('updated_at', { ascending: false });

      const cleanedData = (data ?? []).map((item: ExperimentRow) => ({
        id: item.id,
        name: item.title,
        updatedAt: item.updated_at,
      }));

      setExperiments(cleanedData);
    } catch (error) {
      console.error('Error fetching experiments from user:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchExperiments();
  }, [user, supabase]);

  return {
    experiments,
    loading,
  };
};
